export const DS_LABEL_CLASSES = {
  Root: "ds-label",
  Caption: "ds-label__caption",
  Prefix: "ds-label__prefix",
  Suffix: "ds-label__suffix",
  WithDivider: "ds-label--with-divider",
  WithTooltip: "ds-label--with-tooltip",
  RequiredAsterisk: "ds-label__required-asterisk",
  Text: "ds-label__text",
  CaptionHidden: "ds-label__caption--hidden",
} as const;
